import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProfileModel } from "src/app/models/profile.model";
import { Subscription } from "rxjs";
import { DataService } from "src/app/services/data/data.service";
import { take } from "rxjs/operators";
import { HomeService } from "src/app/services/home-service/home.service";

@Component({
  selector: "producer-view",
  templateUrl: "./producer-view.component.html",
  styleUrls: ["./producer-view.component.scss"]
})
export class ProducerViewComponent implements OnInit {
  @Input()
  producer: ProfileModel;
  subscription: Subscription;
  loading = true;

  constructor(public route: ActivatedRoute, private dataService: DataService, private homeService:HomeService) {
    this.route.data.subscribe(data => {
      if (data.producer) {
        this.dataService.getProducerDetails(data.producer.key).pipe(take(1)).subscribe(details => {
          this.producer.details = details;
          this.loading = false;
        });
      }
    });
  }

  ngOnInit(): void {
    //
  }

  viewSales():void{
    this.homeService.viewPublicProfile(this.producer);
  }
}
